import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/cate/goodsDetail.vue'
createPage(Page)